import * as React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AccountCircle from "@material-ui/icons/AccountCircle";

import { ApplicationState, personalInformationGetRequest, selectPersonalInformation } from "../../redux/ducks";
import testingHooks from "../../testing-hooks";

const mstp = (state: ApplicationState) => ({
  personalInformation: selectPersonalInformation(state),
});

const actions = { getPersonalInformation: personalInformationGetRequest.actionCreator };

class ProfileTool extends React.Component<ReturnType<typeof mstp> & typeof actions> {
  public componentDidMount() {
    this.props.getPersonalInformation();
  }

  public render() {
    const { personalInformation } = this.props;

    return (
      <Tooltip title={<FormattedMessage id={"tooltip.profile"} defaultMessage={"Profile"} />}>
        <Link to={"/profile"} href={"/profile"}>
          <IconButton data-test-id={testingHooks.tools.profile} color={"inherit"}>
            {personalInformation && personalInformation.photo && personalInformation.photo != "https://pic1.png" ? <Avatar src={personalInformation.photo} /> : <AccountCircle />}
          </IconButton>
        </Link>
      </Tooltip>
    );
  }
}

export default connect(mstp, actions)(ProfileTool);



// WEBPACK FOOTER //
// ./src/components/molecules/ProfileTool.tsx